<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>КБК</h3>
            </v-flex>
            <v-flex xs12 sm12 class="text-xs-right">
                <v-dialog v-model="dialog">

                    <v-tabs
                            color="primary"
                            dark
                            slider-color="white">
                        <v-tab href="#tab-1">
                            Основные данные
                        </v-tab>
                        <v-tab-item :value="'tab-1'">
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }} {{item.id}}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        v-model.trim="item.name"
                                                        label="КБК"
                                                        :error-messages="requiredErrors('name')"
                                                        @blur="$v.item.name.$touch()"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm3>
                                                <v-text-field
                                                        v-model.trim="item.date_start"
                                                        type="date"
                                                        label="Дата начала действия"
                                                        :error-messages="requiredErrors('date_start')"
                                                        @blur="$v.item.date_start.$touch()"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm3>
                                                <v-text-field
                                                        v-model.trim="item.date_finish"
                                                        type="date"
                                                        label="Дата окончания действия"
                                                        :error-messages="requiredErrors('date_finish')"
                                                        @blur="$v.item.date_finish.$touch()"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm12>
                                                <v-textarea
                                                        v-model.trim="item.caption"
                                                        label="Описание"
                                                        :error-messages="requiredErrors('caption')"
                                                        @blur="$v.item.caption.$touch()"
                                                ></v-textarea>
                                            </v-flex>
                                            <v-flex xs12 sm12>
                                                <v-textarea
                                                        v-model.trim="item.koap_item"
                                                        label="Статья КоАП"
                                                        :error-messages="requiredErrors('koap_item')"
                                                        @blur="$v.item.koap_item.$touch()"
                                                ></v-textarea>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-autocomplete
                                                        v-bind:items="discounts"
                                                        item-text="name"
                                                        item-value="id"
                                                        v-model="item.discount"
                                                        label="Вид скидки"
                                                        :loading="listLoading.includes('gis_gmpFetchDiscount')"
                                                >
                                                </v-autocomplete>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        v-model.trim="item.discount_fixed_value"
                                                        type="number"
                                                        label="Поле номер 1004: Сумма скидки от полной суммы начисления"
                                                        prefix="₽"
                                                        :error-messages="requiredErrors('discount_fixed_value')"
                                                        @blur="$v.item.discount_fixed_value.$touch()"
                                                        v-show="item.discount===1"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        v-model.trim="item.discount_fixed_expiry_days"
                                                        type="number"
                                                        label="Поле номер 1005: Количество дней предоcтавления скидки"
                                                        :error-messages="requiredErrors('discount_fixed_expiry_days')"
                                                        @blur="$v.item.discount_fixed_expiry_days.$touch()"
                                                        v-show="item.discount===1"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        v-model.trim="item.discount_sice_value"
                                                        type="number"
                                                        label="Поле номер 1006: Процент скидки от суммы начисления"
                                                        prefix="%"
                                                        :error-messages="requiredErrors('discount_sice_value')"
                                                        @blur="$v.item.discount_sice_value.$touch()"
                                                        v-show="item.discount===2"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        v-model.trim="item.discount_sice_expiry_days"
                                                        type="number"
                                                        label="Поле номер 1007: Количество дней предоcтавления скидки"
                                                        :error-messages="requiredErrors('discount_sice_expiry_days')"
                                                        @blur="$v.item.discount_sice_expiry_days.$touch()"
                                                        v-show="item.discount===2"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        v-model.trim="item.multiplier_size_value"
                                                        type="number"
                                                        label="Поле номер 1008: Коэффициент, понижающий размер начисления"
                                                        :error-messages="requiredErrors('multiplier_size_value')"
                                                        @blur="$v.item.multiplier_size_value.$touch()"
                                                        v-show="item.discount===3"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        v-model.trim="item.multiplier_size_expiry_days"
                                                        type="number"
                                                        label="Поле номер 1009: Количество дней предоcтавления скидки"
                                                        :error-messages="requiredErrors('multiplier_size_expiry_days')"
                                                        @blur="$v.item.multiplier_size_expiry_days.$touch()"
                                                        v-show="item.discount===3"
                                                ></v-text-field>
                                            </v-flex>

                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="close">Отменить</v-btn>
                                    <v-btn @click.native="save">Сохранить</v-btn>
                                    <v-btn
                                            v-if="(item.id !== null)"
                                            @click.native="del">Удалить
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                        <v-tab href="#tab-2">
                            Системные данные
                        </v-tab>
                        <v-tab-item :value="'tab-2'">
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }} {{item.id}}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12>
                                                <table>
                                                    <tr>
                                                        <th>Пользователь</th>
                                                        <td>{{item.user}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Дата создания</th>
                                                        <td>{{ item.date_created|date_time }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Дата модификации</th>
                                                        <td>{{ item.date_of_change|date_time }}</td>
                                                    </tr>
                                                </table>
                                            </v-flex>

                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-dialog>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <v-toolbar flat color="white">
                    <!--<v-toolbar-title>Expandable Table</v-toolbar-title>-->
                    <v-text-field
                            v-model.trim="search"
                            label="Фильтр"
                            v-on:change="initialize(true)"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-icon
                            large
                            class="mr-2 mt-4"
                            @click="initialize(true)"
                    >
                        mdi-magnify
                    </v-icon>
                </v-toolbar>
                <v-data-table
                        :items="listKBK.results"
                        :server-items-length="listKBK.last_page"
                        :loading="listLoading.includes('gis_gmpListKBK')"
                        hide-default-footer
                        v-model="listKBK.results"
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1">
                    <template v-slot:header>
                        <tr>
                            <th>Код</th>
                            <th>КБК</th>
                            <th>Описание</th>
                            <th>Статья</th>
                            <th>Скидка</th>
                            <th>Дата начала действия</th>
                            <th>Дата окончания действия</th>
                            <th>
                                <v-btn
                                        icon
                                        class="mr-2"
                                        @click="editItem({item: {id: null}})"
                                >
                                    <v-icon>mdi-pencil-plus</v-icon>
                                </v-btn>

                            </th>
                        </tr>
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.caption }}</td>
                                <td>{{ item.koap_item }}</td>
                                <td>{{ item.discount_name }}</td>
                                <td>{{ item.date_start|short_date }}</td>
                                <td>{{ item.date_finish|short_date }}</td>
                                <td class="justify-center mx-0">
                                    <v-btn
                                            icon
                                            class="mr-2"
                                            @click="editItem(item)"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                    <!--<template slot="no-data">-->
                        <!--<v-btn color="primary" @click="initialize">Перегрузить</v-btn>-->
                    <!--</template>-->
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="listKBK.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import { toISODate } from '../../../common/tools'

export default {
  data () {
    return {
      dialog: false,
      item: {
        id: null,
        name: '',
        caption: '',
        date_start: null
      },
      default_item: {
        id: null,
        name: '',
        caption: '',
        date_start: toISODate()
      },
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    // name: { required, maxLength: maxLength(10) },
    item: {
      name: { required },
      caption: { required },
      koap_item: { required },
      date_start: { required },
      date_finish: {},
      discount_fixed_value: { minValue: minValue(0) },
      discount_fixed_expiry_days: { minValue: minValue(0) },
      discount_sice_value: { minValue: minValue(0), maxValue: maxValue(100) },
      discount_sice_expiry_days: { minValue: minValue(0) },
      multiplier_size_value: { minValue: minValue(0), maxValue: maxValue(1) },
      multiplier_size_expiry_days: { minValue: minValue(0) }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    packages () {
      return this.$store.getters['gis_gmpPackage/packages']
    },
    discounts () {
      return this.$store.getters['gis_gmpReferenceTables/discounts']
    },
    listKBK () {
      return this.$store.getters['gis_gmpReferenceTables/listKBK']
    },
    formTitle () {
      return this.item.id === null ? 'Добавить запись' : 'Запись'
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    },
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    initialize (newSearch = false) {
      this.$store.dispatch('gis_gmpReferenceTables/fetchListKBK', {
        pageId: (newSearch) ? 1 : this.pagination.page,
        search: this.search
      }).then(() => {
        if (newSearch) {
          this.pagination.page = 1
        }
      })
    },
    editItem (item) {
      this.dialog = true
      if (item.id == null) { this.item = JSON.parse(JSON.stringify(this.default_item)) } else { this.item = JSON.parse(JSON.stringify(item)) }
    },
    close () {
      this.dialog = false
      this.item = { id: null }
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch(
          'gis_gmpReferenceTables/insertKBK',
          this.item
        )
        this.close()
      }
    },
    del () {
      if (this.receipt_id !== null) {
        this.$store.dispatch('gis_gmpReferenceTables/deleteKBK', this.item.id)
        // .then(() => {
        //   this.initialize()
        // })
        // .catch(() => {
        //   this.initialize()
        // })
        this.close()
      }
    },
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v.item[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      if (field.hasOwnProperty('minValue')) {
        !field.minValue && errors.push('Убедитесь, что значение не меньше ' + field.$params.minValue.min)
      }
      if (field.hasOwnProperty('maxValue')) {
        !field.maxValue && errors.push('Убедитесь, что значение не больше ' + field.$params.maxValue.max)
      }
      if (field.hasOwnProperty('email')) {
        !field.email && errors.push('Это не адрес электронной почты')
      }
      if (field.hasOwnProperty('validatorRus')) {
        !field.validatorRus && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorPhone')) {
        !field.validatorPhone && errors.push('Некорректные символы')
      }
      return errors
    }

  },
  created: function () {
    this.initialize()
    this.$store.dispatch('gis_gmpReferenceTables/fetchListDiscount')
  }
}
</script>

<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
